import { Customer } from "./customer";

export class Company {
    id : number;
    idExternal: string;
    name : string;
    fantasy : string;
    address : string;
    number : string;
    complement : string;
    neighborhood : string;
    city : string;
    state : string;
    country : string;
    zipcode : string;
    stateInscrition : string; //state_inscrition
    rg : string;
    rgIssuingBody : string; //rg_issuing_body
    rgIssuingBodyState : string; //rg_issuing_body_state
    rgEmissionDate : Date; //rg_emission_date
    cpf : string;
    cnpj : string;
    type : number;
    tel : string;
    cel : string;
    email : string;
    deliveryAddress : string; //delivery_address
    deliveryNumber : string; //delivery_number
    deliveryComplement : string; //delivery_complement
    deliveryNeighborhood : string; //delivery_neighborhood
    deliveryCity : string; //delivery_city
    deliveryState : string; //delivery_state
    deliveryCountry : string; //delivery_country
    deliveryZipcode : string; //delivery_zipcode
    
    //Ahura Marker properties
    isDemandingGeo: boolean; //is_demanding_geo
    dtLastMarkerSync: Date;
    dtLastMarkerGeo:Date;

    lat : string;
    lng : string;
    deliveryLat : string; //delivery_lat
    deliveryLng : string; //delivery_lng
    customer: Customer;

    timeDischarge: number;
    timeVisit: number;

    visitEstimatedDuration: number;
    visitEstimatedDistance: number;
    visitEstimatedDurationText: string;
    visitEstimatedDistanceText: string;

    visitEstimatedArrivedDate: Date; 

    isOnVisitList:boolean = false;

    constructor(id : number,
                name : string,
                fantasy : string,
                address : string,
                number : string,
                complement : string,
                neighborhood : string,
                city : string,
                state : string,
                country : string,
                zipcode : string,
                stateInscrition : string,
                rg : string,
                rgIssuingBody : string, 
                rgIssuingBodyState : string, 
                rgEmissionDate : Date,
                cpf : string,
                cnpj : string,
                type : number,
                tel : string,
                cel : string,
                email : string,
                deliveryAddress : string,
                deliveryNumber : string,
                deliveryComplement : string,
                deliveryNeighborhood : string,
                deliveryCity : string,
                deliveryState : string,
                deliveryCountry : string,
                deliveryZipcode : string,
                isDemandingGeo : boolean,
                lat : string,
                lng : string,
                deliveryLat : string,
                deliveryLng : string,
                timeDischarge: number,
                timeVisit: number,
                customer:Customer,
                idExternal:string,
                dtLastMarkerSync: Date,
                dtLastMarkerGeo:Date
                ) {
                //Sets
                this.id = id;
                this.name = name;
                this.fantasy = fantasy;
                this.address = address;
                this.number = number;
                this.complement = complement;
                this.neighborhood = neighborhood;
                this.city = city;
                this.state = state;
                this.country = country;
                this.zipcode = zipcode;
                this.stateInscrition = stateInscrition; //state_inscrition
                this.rg = rg;
                this.rgIssuingBody = rgIssuingBody; //rg_issuing_body
                this.rgIssuingBodyState = rgIssuingBodyState; //rg_issuing_body_state
                this.rgEmissionDate = rgEmissionDate; //rg_emission_date
                this.cpf = cpf;
                this.cnpj = cnpj;
                this.type = type;
                this.tel = tel;
                this.cel = cel;
                this.email = email;
                this.deliveryAddress = deliveryAddress; //delivery_address
                this.deliveryNumber = deliveryNumber; //delivery_number
                this.deliveryComplement = deliveryComplement; //delivery_complement
                this.deliveryNeighborhood = deliveryNeighborhood; //delivery_neighborhood
                this.deliveryCity = deliveryCity; //delivery_city
                this.deliveryState = deliveryState; //delivery_state
                this.deliveryCountry = deliveryCountry; //delivery_country
                this.deliveryZipcode = deliveryZipcode; //delivery_zipcode
                this.isDemandingGeo = isDemandingGeo;
                this.dtLastMarkerGeo = dtLastMarkerGeo;
                this.dtLastMarkerSync = dtLastMarkerSync;
                this.lat = lat;
                this.lng = lng;
                this.deliveryLat = deliveryLat; //delivery_lat
                this.deliveryLng = deliveryLng;
                this.timeDischarge = timeDischarge;
                this.timeVisit = timeVisit;
                this.customer = customer;
                this.idExternal = idExternal;
    }

    get idCustom():any {
        if (this.idExternal && this.idExternal.length > 0) {
            return this.idExternal;
        } else {
            return this.id;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/company.ts